import {
  SET_FORECAST_DEPRECIATION_DATA,
  SET_FORECAST_DEPRECIATION,
} from "./mutations";
import {store} from "../../index";
import ForecastedDepreciation from "../../../models/valuation/ForecastedDepreciation";
import { generateForecastedRevenue } from "../valuation/actions";


export const setForecastDepreciationData = (payload) => ({
  type: SET_FORECAST_DEPRECIATION_DATA,
  payload,
});

export const generateForecastedDepreciation = (options = { clearCache: false }) => (dispatch) => {
  dispatch(generateForecastedRevenue())

  const { taxes, forecastDepreciation } = store.getState()
  const { forecastedRevenue } = store.getState().valuation;

  const growthRateMultiplier = (taxes.growthRate / 100) + 1
  if (forecastDepreciation?.forecastedDepreciation && !options.clearCache) {
    dispatch({
      type: SET_FORECAST_DEPRECIATION,
      payload: new ForecastedDepreciation({
        ...forecastDepreciation.forecastedDepreciation,
        growthRate: growthRateMultiplier,
        forecastedRevenue: forecastedRevenue?.forecastedValue
      })
    })

    return
  }

  dispatch({
    type: SET_FORECAST_DEPRECIATION,
    payload: new ForecastedDepreciation({
      growthRate: growthRateMultiplier,
      forecastedRevenue: forecastedRevenue?.forecastedValue
    })
  })
}

export const updateForecastDepreciation = ({ depreciationPercentageRevenue, analystNote }) => (dispatch) => {
  const storedForecastedDepreciation = new ForecastedDepreciation({
    ...store.getState().forecastDepreciation.forecastedDepreciation
  })

  if (depreciationPercentageRevenue) storedForecastedDepreciation.depreciationPercentageRevenue = depreciationPercentageRevenue
  if (analystNote || analystNote === "") storedForecastedDepreciation.analystNote = analystNote

  dispatch({
    type: SET_FORECAST_DEPRECIATION,
    payload: storedForecastedDepreciation
  })
}

